module.exports = __webpack_public_path__ + "static/img/h5-2.04de1ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/h5-2.png
// module id = xkOB
// module chunks = 1